import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStateOngoing = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 12,
	viewBox: "0 0 14 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M1.914 11.786 7.7 6.001 1.914.215.5 1.629l4.371 4.372L.5 10.372l1.414 1.414z",
		fill: "#0058A3"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M7.714 11.786 13.5 6.001 7.714.215 6.3 1.629l4.37 4.372-4.37 4.371 1.414 1.414z",
		fill: "#0058A3"
	})]
});
export default SvgStateOngoing;
